import React from "react";
import DataTable from "react-data-table-component";
import noDataImage from "../assets/images/TableBg.svg";
import { useLocation, useNavigate } from "react-router-dom";

const ReactDataTable = ({
  columns,
  data,
  selectedPatientId,
  conditionalRowStyles,
  noDataComponent,
  selectableRows,
  onSelectedRowsChange,
  screen = "",
  stage = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
        cursor: "pointer",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        overflow: "visible",
        textOverflow: "initial",
        paddingRight: "70px",
      },
    },
    tableWrapper: {
      style: {
        boxShadow: "var(--chakra-shadows-md)",
        borderRadius: "var(--chakra-radii-md)",
      },
    },
    table: {
      style: {
        borderRadius: "var(--chakra-radii-md)",
      },
    },

    headCells: {
      style: {
        backgroundColor: "#2B67AF",
        color: "white",
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    columns: {
      centerColumn: {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
    },
  };

  const RowStyles = [
    {
      when: (row) => row.id === selectedPatientId,
      style: {
        backgroundColor: "#50C878",
      },
    },
  ];

  const NoDataComponent = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
        fontSize: "20px",
      }}
    >
      <img
        src={noDataImage}
        alt="No records"
        style={{ marginBottom: "20px", maxWidth: "30%" }}
      />
      There are no records to display
    </div>
  );

  const handleRowClick = (row, event) => {
    // Don't navigate if clicking checkbox in bulk approval mode
    if (event.target.type === "checkbox") return;

    let isPatientArrivals = false;
    let isMedicalOpinion = false;
    let isVilRequests = false;

    if (screen === "Existing Patients") {
      if (stage === "medical_opinion") isMedicalOpinion = true;
      if (stage === "vil_requests") isVilRequests = true;
      if (stage === "pickup_details") isPatientArrivals = true;
    } else {
      isPatientArrivals = location.pathname.includes("patient_arrivals");
      isMedicalOpinion = location.pathname.includes("medical_opinion");
      isVilRequests = location.pathname.includes("vil_requests");
    }

    navigate("/patient", {
      state: {
        trid: screen === "Notifications" ? row.tr_id : row.id,
        from: isPatientArrivals
          ? "patient_arrivals"
          : isMedicalOpinion
          ? "medical_opinion"
          : isVilRequests
          ? "vil_requests"
          : null,
      },
    });
  };

  return (
    <DataTable
      columns={columns}
      data={data}
      customStyles={customStyles}
      conditionalRowStyles={
        conditionalRowStyles ? conditionalRowStyles : RowStyles
      }
      noDataComponent={noDataComponent ? noDataComponent : <NoDataComponent />}
      onRowClicked={handleRowClick}
      selectableRows={selectableRows}
      onSelectedRowsChange={onSelectedRowsChange}
      striped
      pagination
      responsive
      scrollable
      //   fixedHeader
      //   noHeader
      //   dense
    />
  );
};

export default ReactDataTable;
